import React, { useMemo } from "react";
import cn from "classnames";
import FullWidthModal from "@components/common/Modal/FullWidthModal";
import { LABEL } from "../../../../veriables";
import ModalHeader from "../../../common/ModalHeader/index";
import { TouchableButton, TouchableDiv } from "../../../common/Touchable/index";
import styles from "../index.module.scss";
import { connect } from "react-redux";

const CreateCheck = ({
  check,
  isLoyaltyOpen,
  serverAppTheme,
  setIsLoyaltyOpen,
  loyaltyList,
  handleLoyaltyItem,
  setSingleLoyalty,
  singleLoyalty,
  setSeatList,
  orderingPortraitOrientation
}) => {
  const popUpModal = useMemo(() => {
    const okButton = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: "#ffff",
      border: "none",
      borderRadius: "8px",
    };

    return { okButton };
  }, [serverAppTheme]);

  return (
    <FullWidthModal
      isOpen={isLoyaltyOpen}
      noBackground
      customClass2={cn('w-100 h-100 position-relative')}
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        pointerEvents: 'auto',
        backgroundColor: serverAppTheme?.popUp_bg,
        backgroundClip: 'padding-box',
        border: '0',
        boxShadow: serverAppTheme?.popUp_box_shadow,
      }}
    >
      <div
        className="col-12 px-0 justify-content-center align-items-center position-relative text-center h-100"
        style={popUpModal.primaryTextColor}
      >
        <div
          className={cn(
            "col-12 px-0 fs_18 align-items-center justify-content-center fw-600 h-100",
          )}
        >
          <ModalHeader
            isTab={check?.tab}
            stationName={check?.stationName}
            tileHeader={LABEL().SSE_SELECT_LOYALTY_ACCOUNT_HEADER}
            seatNumber={check?.number}
          />
          <div className="fs_18 fw-600 text-center py-3">
            {LABEL().SSE_SELECT_LOYALTY_ACCOUNT}
          </div>
          <div
            className={cn(
              "col-12 px-0 large-input m-auto justify-content-center  position-relative h-90",
            )}
          >
            <div className={cn("col-12 w-100 overflowY", orderingPortraitOrientation ? 'h-80 px-0' : "h-78 px-3")}>
              <div
                className={cn(
                  "col-12 d-flex p-0 mx-0 flex-wrap justify-content-center w-100",
                  styles.wrapper,
                )}
              >
                {/* split by selected seat loyalty modal */}
                {loyaltyList.length > 0 &&
                  loyaltyList.map((item) => {
                    const isSelected = singleLoyalty?.id === item?.id;
                    return (
                      <TouchableDiv
                        key={item.id}
                        className="d-flex align-items-center justify-content-center flex-column p-2 mx-2 mb-2"
                        style={{
                          // width: "22%", // Max 4 per row with gap
                          width: orderingPortraitOrientation ? '46%' : "22%",
                          minWidth: "120px",
                          borderRadius: "4px",
                          backgroundColor: isSelected
                            ? serverAppTheme.selected
                            : serverAppTheme.unselected,
                            height: orderingPortraitOrientation ? '80px' : ''
                        }}
                        role="presentation"
                        onClick={() => {
                          setSingleLoyalty(item);
                        }}
                      >
                        <div
                          className="fw-600 fs_16"
                          style={{ height: "24px", lineHeight: "24px" }}
                        >
                          {item?.guestName || ""}
                        </div>
                        <div
                          className={cn(orderingPortraitOrientation ? 'fs_20 fw-600' : 'fs_16 fs-400')}
                          style={{ height: "24px" }}
                        >
                          {item?.displayAccountNumber || ""}
                        </div>
                      </TouchableDiv>
                    );
                  })}
              </div>
            </div>
            <div className={cn("d-flex col-12 justify-content-center", orderingPortraitOrientation ? 'position-absolute pb-3' : '')} style={{ bottom: orderingPortraitOrientation ? '9px' : ''}}>
              <div className={cn(orderingPortraitOrientation ? 'col-6 pl-0 pr-1' : 'col-5 pr-1')}>
                <TouchableButton
                  type="button"
                  className={cn(
                    "pr-0  pl-2  rounded btn-ripple fw-600 w-100", orderingPortraitOrientation ? 'btn68' : 'btn44 mt-2 mb-2'
                  )}
                  onClick={() => {
                    setIsLoyaltyOpen(false);
                    setSeatList([]);
                    setSingleLoyalty(null);
                  }}
                  style={{
                    backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                    border: serverAppTheme?.cancleBtn_Border,
                    color: serverAppTheme?.cancleBtn_font,
                  }}
                  rippleEffect={true}
                >
                  {LABEL().SSE_CANCEL}
                </TouchableButton>
              </div>
              <div className={cn(orderingPortraitOrientation ? 'col-6 pl-1 pr-0' : 'col-5 pl-1 pr-0')}>
                <TouchableButton
                  className={cn("w-100  btn-ripple", orderingPortraitOrientation ? 'btn68' : 'btn44 mt-2')}
                  type="button"
                  onClick={handleLoyaltyItem}
                  style={popUpModal.okButton}
                  rippleEffect={true}
                >
                  <div className={("fw-600", orderingPortraitOrientation ? 'fs_28' : 'fs_24')}>{LABEL().SSE_OK}</div>
                </TouchableButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FullWidthModal>
  );
};
const mapStateToProps = ({ orders }) => ({
  orderingPortraitOrientation: orders.orderingPortraitOrientation
});
export default connect(mapStateToProps) (CreateCheck);
